class BrunchStore {
    data = [];

    constructor (data = {}) {
        this.data = data;
    }

    setData (key, data) {
        this.data[key] = data;
    }

    getData (key) {
        return this.data[key];
    }
}

export const brunchStore = new BrunchStore({
    // footerScript.vm 에서 서버에서 설정된 값을 window.B 객체에 주입
    user: window.B.User ?? {},
    config: window.B.Config ?? {},
});
